// core/services/trendsService.ts — B4c: API-backed trending hashtags.
// Thin fetch over the public /api/trends/ endpoint (derived from real posts).

import type { Trend } from '@/core/models/trend';
import { api } from '@/core/lib/apiClient';

export const trendsService = {
  /** Top trending hashtags, derived server-side from real post bodies. */
  async list(): Promise<Trend[]> {
    return api<Trend[]>('/trends/');
  },
} as const;
